import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedinIn,
  faXTwitter,
  faYoutube,
  faFacebookF,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import '../styles/Footer.css';

function Footer(): React.ReactElement {
  return (
    <footer className="app-footer" data-testid="app-footer">
      <div className="footer-container">
        {/* Left side - Logo and Links */}
        <div className="footer-left">
          <div className="footer-logo">
            <div className="servicenow-logo-container">
              <img
                src="/images/servicenow-logo.svg"
                alt="ServiceNow Logo"
                className="servicenow-logo-img"
              />
            </div>
          </div>

          <div className="footer-links">
            <a href="#terms" className="footer-link">
              Terms and conditions
            </a>
            <a href="#privacy" className="footer-link">
              Privacy statement
            </a>
            <a href="#gdpr" className="footer-link">
              GDPR
            </a>
            <a href="#cookies" className="footer-link">
              Cookie policy
            </a>
          </div>
        </div>

        {/* Right side - Social Links and Copyright */}
        <div className="footer-right">
          <div className="social-links">
            <a
              href="https://www.linkedin.com/company/servicenow"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              href="https://twitter.com/servicenow"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Twitter"
            >
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
            <a
              href="https://www.youtube.com/user/servicenowdemo"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a
              href="https://www.facebook.com/servicenow"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a
              href="https://www.instagram.com/servicenow"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
          <div className="copyright">
            ©{new Date().getFullYear()} ServiceNow. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
